import { CommonParamsType } from 'api-hooks/common';

// Model

export class TransactionCategoryLiteModel {
  id: string;
  name: string;
}

export class TransactionCategoryModel extends TransactionCategoryLiteModel {}

// Input

export type getTransactionCategoriesInput = {
  params?: CommonParamsType;
};

export type getTransactionCategoryInput = {
  id: string;
};

export type TransactionCategoryMutationInput = {
  name: string;
};

export type TransactionCategoryUpdateInput = {
  id: string;
  body: TransactionCategoryMutationInput;
};

export type TransactionCategoryDeleteInput = {
  id: string;
};
